<template>
  <tabs
    v-if="staff"
    :tab-name="['Detail', 'Notes']"
    :tab-icon="['event_available', 'text_snippet']"
    class="page-subcategories"
    nav-pills-icons
    color-button="primary"
  >
    <template slot="tab-pane-1">
      <staff-edit :staff="staff" v-on:staffUpdated="staffUpdated" />
    </template>

    <template slot="tab-pane-2">
      <staff-tabs-notes :staff="staff" />
    </template>
  </tabs>
</template>

<script>
import { Tabs } from "@/components";
import staffApi from "@/services/api/staff";

import StaffEdit from "./StaffEdit";
import StaffTabsNotes from "./StaffTabsNotes";

export default {
  props: ["staff"],

  components: {
    Tabs,
    StaffEdit,
    StaffTabsNotes
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    staffUpdated(updateInfo) {
      this.$emit("staffUpdated", updateInfo);
    }
  }
};
</script>
